webpackJsonp([110386547663024],{

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n    padding: 2em 1.5em;\n    margin: 0 auto;\n    max-width: ", ";\n  "], ["\n    padding: 2em 1.5em;\n    margin: 0 auto;\n    max-width: ", ";\n  "]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    h1 {\n      font-size: 1.5em;\n      text-transform: capitalize;\n      font-weight: 600;\n      text-align: center;\n      margin: 2rem 0 4rem;\n      line-height: 1.25;\n    }\n    span {\n      margin: 0 0 0 0.25em;\n    }\n    a {\n      transition: all 0.2s;\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    h1 {\n      font-size: 1.5em;\n      text-transform: capitalize;\n      font-weight: 600;\n      text-align: center;\n      margin: 2rem 0 4rem;\n      line-height: 1.25;\n    }\n    span {\n      margin: 0 0 0 0.25em;\n    }\n    a {\n      transition: all 0.2s;\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n    }\n  "]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    font-size: 3em;\n    font-weight: 600;\n    text-align: center;\n    margin: 0 0 1em 0;\n  "], ["\n    font-size: 3em;\n    font-weight: 600;\n    text-align: center;\n    margin: 0 0 1em 0;\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: space-between;\n    margin: 0 auto;\n    &:after {\n      content: \"\";\n      @media screen and (min-width: ", ") {\n        flex: 0 0 49%;\n      }\n      @media screen and (min-width: ", ") {\n        flex: 0 0 32%;\n      }\n    }\n  "], ["\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: space-between;\n    margin: 0 auto;\n    &:after {\n      content: \"\";\n      @media screen and (min-width: ", ") {\n        flex: 0 0 49%;\n      }\n      @media screen and (min-width: ", ") {\n        flex: 0 0 32%;\n      }\n    }\n  "]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    border: 1px solid ", ";\n    border-radius: 2px;\n    margin: 0 0 1em 0;\n    width: 100%;\n    @media screen and (min-width: ", ") {\n      flex: 0 0 49%;\n    }\n    @media screen and (min-width: ", ") {\n      flex: 0 0 32%;\n    }\n  "], ["\n    border: 1px solid ", ";\n    border-radius: 2px;\n    margin: 0 0 1em 0;\n    width: 100%;\n    @media screen and (min-width: ", ") {\n      flex: 0 0 49%;\n    }\n    @media screen and (min-width: ", ") {\n      flex: 0 0 32%;\n    }\n  "]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    flex: 0 1 100%;\n    color: ", ";\n    text-decoration: none;\n\n    div {\n      flex-grow: 1;\n      width: 100%;\n      height: 100%;\n    }\n\n    h3 {\n      font-weight: 600;\n      text-transform: capitalize;\n      text-align: center;\n      margin: 1em 0;\n    }\n  "], ["\n    display: flex;\n    flex-flow: column;\n    height: 100%;\n    flex: 0 1 100%;\n    color: ", ";\n    text-decoration: none;\n\n    div {\n      flex-grow: 1;\n      width: 100%;\n      height: 100%;\n    }\n\n    h3 {\n      font-weight: 600;\n      text-transform: capitalize;\n      text-align: center;\n      margin: 1em 0;\n    }\n  "]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(36);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(30);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _siteConfig = __webpack_require__(42);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Campaigns = function Campaigns(_ref) {
	  var data = _ref.data;
	
	  var Wrapper = _styledComponents2.default.section(_templateObject, function (props) {
	    return props.theme.sizes.maxWidth;
	  });
	
	  var Header = _styledComponents2.default.div(_templateObject2, function (props) {
	    return props.theme.colors.base;
	  }, function (props) {
	    return props.theme.colors.highlight;
	  });
	
	  var Title = _styledComponents2.default.h2(_templateObject3);
	
	  var List = _styledComponents2.default.ul(_templateObject4, function (props) {
	    return props.theme.responsive.small;
	  }, function (props) {
	    return props.theme.responsive.medium;
	  });
	
	  var Card = _styledComponents2.default.li(_templateObject5, function (props) {
	    return props.theme.colors.secondary;
	  }, function (props) {
	    return props.theme.responsive.small;
	  }, function (props) {
	    return props.theme.responsive.medium;
	  });
	
	  var CampaignLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject6, function (props) {
	    return props.theme.colors.base;
	  });
	
	  var campaigns = data.allContentfulCampaign.edges;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(
	      Header,
	      null,
	      _react2.default.createElement(
	        "h1",
	        null,
	        "All Campaigns",
	        _react2.default.createElement(
	          "span",
	          null,
	          "\uD83D\uDCA6"
	        )
	      )
	    ),
	    campaigns && _react2.default.createElement(
	      List,
	      null,
	      campaigns.map(function (_ref2) {
	        var campaign = _ref2.node,
	            index = _ref2.index;
	
	        return _react2.default.createElement(
	          Card,
	          { key: campaign.id },
	          _react2.default.createElement(
	            CampaignLink,
	            { to: "/campaigns/" + campaign.slug + "/" },
	            _react2.default.createElement(_gatsbyImage2.default, {
	              sizes: campaign.heroImage.sizes,
	              backgroundColor: "#EEEEEE"
	            }),
	            _react2.default.createElement(
	              "h3",
	              null,
	              campaign.title
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";
	
	exports.default = Campaigns;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-campaigns-js-46c2bf4ecf9cda7eb789.js